<div>
  <div *ngIf="unassignedData" style="margin-top: 16px">
    <p><strong>Assigning customers for:</strong></p>
    <p>Temp Rep Name: {{unassignedData.temp_rep_name}}</p>
    <p>Company: {{unassignedData.company}}</p>
  </div>

    <form [formGroup]="repForm">
        <nz-form-item *ngIf="hasPermission('view_all_users')">
            <nz-form-label>Distributor</nz-form-label>
            <nz-select [nzLoading]="dLoading" (ngModelChange)="getCompaniesByDistributor()" nzPlaceHolder="Select Distributor" formControlName="distributor" style="width: 100%;">
              <nz-option *ngFor="let d of distributors" [nzLabel]="d.name" [nzValue]="d.id"></nz-option>
            </nz-select>
        </nz-form-item>

        <nz-form-item *ngIf="hasPermission('view_distributor_users') && repForm.get('distributor')?.value">
            <nz-form-label>Company</nz-form-label>
            <nz-select [nzLoading]="cLoading" (ngModelChange)="getUsersByCompany()" nzPlaceHolder="Select Company" formControlName="company" style="width: 100%;">
              <nz-option *ngFor="let c of companies" [nzLabel]="c.name" [nzValue]="c.id"></nz-option>
            </nz-select>
        </nz-form-item>

        <nz-form-item *ngIf="repForm.get('company')?.value">
            <nz-form-label>Rep</nz-form-label>
            <nz-select [nzLoading]="rLoading" nzPlaceHolder="Select Rep" formControlName="rep" style="width: 100%;" [nzShowSearch]="true">
              <nz-option *ngFor="let u of users" [nzLabel]="u.first_name + ' ' + u.last_name" [nzValue]="u.id"></nz-option>
            </nz-select>
        </nz-form-item>
    </form>

    <div style="display: flex; gap: 5px; flex-direction: column;">
      <button nz-button nzType="default" (click)="cancel()">Cancel</button>
      <button [nzLoading]="saving" nz-button nzType="primary" (click)="save()">Save</button>
    </div>
</div>
